export default __webpack_public_path__ + "static/media/Shoes9.b7faa162.png";